import React, {ReactElement, ReactNode} from 'react';
import {DeleteButton} from 'components/DeleteButton';
import {SwipeProvider} from 'components/SwipeProvider';
import {Container, SwipeContainer, ButtonContainer} from './style';

interface DeletableProps {
  children: ReactNode;
  onDelete: () => void;
}

export const Deletable = ({children, onDelete}: DeletableProps): ReactElement => {
  const deleteButtonWidth = 125;

  return (
    <Container>
      <ButtonContainer>
        <DeleteButton onPress={onDelete} />
      </ButtonContainer>
      <SwipeProvider maxDisplacement={deleteButtonWidth} autoCompleteTranslation>
        <SwipeContainer data-test='swipe'>{children}</SwipeContainer>
      </SwipeProvider>
    </Container>
  );
};
